import { FC } from 'react';
import { Image } from 'antd';
import { Container } from './NoData.styles';
import Title from '../Title';
import type { NoDataProps } from './NoData.types';
import noData from '@/assets/images/no-data.svg';

const NoData: FC<NoDataProps> = ({ title, subtitle, children }) => (
  <Container>
    <Image src={noData} preview={false} />
    <Title level={3}>{title}</Title>
    {subtitle && <Title level={5}>{subtitle}</Title>}
    {children}
  </Container>
);

export default NoData;
